var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#272627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.54-174.62q-19.9 0-34.22-14.97Q20-204.57 20-225.39h138.31q-23.53 0-40.61-17.08t-17.08-40.61v-479.23q0-23.53 17.08-40.61T158.31-820h643.38q23.53 0 40.61 17.08t17.08 40.61v479.23q0 23.53-17.08 40.61t-40.61 17.08H940q0 21.16-14.98 35.97-14.97 14.8-35.79 14.8H68.54Zm411.46-17q12.14 0 19.99-7.85 7.86-7.85 7.86-19.8 0-11.95-7.86-19.99-7.85-8.05-19.99-8.05-12.14 0-19.99 8.1-7.86 8.11-7.86 19.75 0 12.14 7.86 19.99 7.85 7.85 19.99 7.85Zm-321.69-79.15h643.38q4.62 0 8.46-3.84 3.85-3.85 3.85-8.47v-479.23q0-4.61-3.85-8.46-3.84-3.84-8.46-3.84H158.31q-4.62 0-8.46 3.84-3.85 3.85-3.85 8.46v479.23q0 4.62 3.85 8.47 3.84 3.84 8.46 3.84Zm-12.31 0v-503.84V-270.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.619a90458899535a1bdd2a1cc890362f.svg";
export { ForwardRef as ReactComponent };